<template>
  <footer class="footer" >
    <div class="container pt-20">
      <div class="row">
        <div class="col-lg-4">
          <h5 class="call-us">
            Questions? <br />
            <span class="colorg">
              Call +91 79 9444 1444
              <span style="padding-left: 5px; padding-right: 10px; color: white">
                |
              </span>
              <a href="https://www.facebook.com/palaxicinemas" style="color: #f89723 !important;"><span style="padding-left: 5px; padding-right: 5px">
                <i class="fa fa-facebook-square" aria-hidden="true"></i>
              </span></a>
              <a href="https://www.instagram.com/palaxi_cinemas/" style="color: #f89723 !important;"><i class="fa fa-instagram" aria-hidden="true"></i></a>
            </span>
          </h5>
          <p>
            Palaxi Cinemas are a chain of world-class theatres that aim to upgrade the experience of movie-watching. 
          </p>

          <!-- end language -->
        </div>
        <!-- end col-4 -->
        <div class="col-lg-2 offset-lg-1 col-md-4">
          <h6 class="widget-title">MORE LINKS</h6>
          <ul class="footer-menu">
            <li><router-link to="/index">Home</router-link></li>
            <li><router-link to="/index#movies">Movies</router-link></li>
            <li><router-link to="/index#movies">Coming Soon</router-link></li>

          
          </ul>
        </div>
        <!-- end col-4 -->
        <div class="col-lg-2 col-md-4">
          <h6 class="widget-title">MORE LINKS</h6>
          <ul class="footer-menu">
            <li><router-link to="/contactus">Contact Us</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>

            <!-- <li><router-link to="/">FAQ</router-link></li>
            <li><router-link to="/">Help Center</router-link></li> -->

            
          </ul>
        </div>
        <!-- end col-4 -->
        <div class="col-lg-2 col-md-4">
          <h6 class="widget-title">POLICIES</h6>
          <ul class="footer-menu">
            <li><router-link to="/privacypolicy">Privacy Policy</router-link></li>
            <li><router-link to="/refundpolicy"> Refund Policy</router-link></li>
            <li><router-link to="/termsofservice">Terms & Conditions</router-link></li>
          </ul>
        </div>
        <!-- end col-4 -->
      </div>
      <!-- end row -->
    </div>

    <div class="container tepat">
      <div class="row">
        <hr />

        <div class="col-lg-4 pr-50">
          <div class="pb-20">Technology Partners</div>

          <carousel :dots="false" :autoplay="true" :loop="true" :items="1" :nav="false" :margin="20" :rewind="true"
            :autoplayTimeout="2000" :smartSpeed="800" :responsiveClass="true" :autoHeight="true" :responsive="{
              0: { items: 3 },
              600: { items: 3 },
              1024: {
                items: 4,
              },
              1366: {
                items: 4,
              },
            }">
            <img :src="imgPath+'images/qb.png'" alt="1000X1000" />

<img :src="imgPath+'images/im.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/b.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/screenX-thumb-NEW_tcm307-133267.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/mv.png'" alt="1000X1000" />

            <img :src="imgPath + 'images/tech-partner-dolby_tcm307-131974.png'" alt="1000X1000" />

            <img :src="imgPath + 'images/b.png'" alt="1000X1000" />

            <img :src="imgPath+'images/qb.png'" alt="1000X1000" />

<img :src="imgPath+'images/im.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/screenX-thumb-NEW_tcm307-133267.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/tech-partner-dolby_tcm307-131974.png'" alt="1000X1000" />
            <img :src="imgPath + 'images/mv.png'" alt="1000X1000" />
          
          </carousel>
        </div>
        <div class="col-lg-4 pr-50">
          <div class="pb-20">Partners</div>

          <carousel :dots="false" :autoplay="true" :loop="true" :items="1" :nav="false" :margin="20" :rewind="true"
            :autoplayTimeout="2000" :smartSpeed="800" :responsiveClass="true" :autoHeight="true" :responsive="{
              0: { items: 3 },
              600: { items: 3 },
              1024: {
                items: 4,
              },
              1366: {
                items: 4,
              },
            }">
            <img :src="imgPath + 'images/hi.png'" alt="1000X1000" />

            <img :src="imgPath + 'images/hug.png'" alt="" />

            <img :src="imgPath + 'images/6t6.png'" alt="" />

            <img :src="imgPath + 'images/hi.png'" alt="1000X1000" />

            <img :src="imgPath + 'images/hug.png'" alt="" />
          </carousel>
        </div>
        <div class="col-lg-4">
          <div class="pb-15 xsfont12">Download App</div>

          <span>
            <a href="https://apps.apple.com/in/app/hilite-mall/id1665021598"><img :src="imgPath + 'images/applestore_tcm295-131980.svg'" alt="" class="dowapp" /></a>
          </span>

          <span>
            <a href="https://play.google.com/store/apps/details?id=io.proximety.hilitemall"><img :src="imgPath + 'images/googlestore_tcm295-131981.svg'" alt="" class="dowapp" /></a>
          </span>
        </div>
      </div>
    </div>

    <!-- end container -->
    <div class="bottom-bar">
      <div class="container text-center">
        <span class="fullwid">2024 © Palaxi Cinemas | Ticketing Backend Powered By
          Movieclicks</span>
      </div>
      <!-- end container -->
    </div>

    <!-- end bottom-bar -->
  </footer>
  
</template>

<script>
import carousel from "vue-owl-carousel/src/Carousel";
export default {
  components: {
    carousel,
  },
  data() {
    return {
      imgPath: process.env.BASE_URL,

    }
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
};
</script>
